import Link from 'next/link';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';

interface SummaryCardProps {
  title: string;
  count: number;
  icon: React.ReactNode;
  link: string;
  description: string;
}

export default function SummaryCard({ title, count, icon, link, description }: SummaryCardProps) {
  return (
    <Card className="flex flex-col">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium">{title}</CardTitle>
        {icon}
      </CardHeader>
      <CardContent className="flex-1 flex flex-col justify-between">
        <div>
            <div className="text-2xl font-bold">{count}</div>
            <p className="text-xs text-muted-foreground">{description}</p>
        </div>
        <Button asChild variant="outline" size="sm" className="mt-4 w-full">
            <Link href={link}>
                View Details
                <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
        </Button>
      </CardContent>
    </Card>
  );
}
